import {
  faFile,
  faFileAudio,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faImage,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image as AntdImage } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { isImageUrlFromExtension } from 'utils/files';

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: var(--primary-color);
  width: 14px !important;
  height: 14px !important;
`;
const Image = styled(AntdImage)`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

export const FileExtensionIcon = ({
  name,
  location,
}: {
  name: string;
  location?: string;
}) => {
  if (isImageUrlFromExtension(name)) {
    if (location) {
      return <Image src={location} alt={name} preview={false} loading="lazy" />;
    }

    return <StyledFontAwesomeIcon icon={faImage} />;
  }
  const extension = name.split('.').pop();

  switch (extension) {
    case 'csv':
      return <StyledFontAwesomeIcon icon={faFileCsv} />;

    case 'doc':
    case 'docx':
    case 'odt':
      return <StyledFontAwesomeIcon icon={faFileWord} />;

    case 'xls':
    case 'xlsx':
    case 'ods':
      return <StyledFontAwesomeIcon icon={faFileExcel} />;

    case 'pdf':
      return <StyledFontAwesomeIcon icon={faFilePdf} />;

    case 'ppt':
    case 'pptx':
      return <StyledFontAwesomeIcon icon={faFilePowerpoint} />;

    case 'mp3':
    case 'm4a':
    case 'aac':
    case 'oga':
    case 'flac':
    case 'wav':
    case 'pcm':
    case 'aiff':
      return <StyledFontAwesomeIcon icon={faFileAudio} />;

    case 'mp4':
    case 'm4p':
    case 'm4v':
    case 'mov':
    case 'webm':
    case 'mpg':
    case 'mp2':
    case 'mpeg':
    case 'mpe':
    case 'mpv':
    case 'ogg':
    case 'avi':
    case 'wmv':
    case 'qt':
    case 'flv':
    case 'swf':
    case 'avchd':
      return <StyledFontAwesomeIcon icon={faFileVideo} />;

    case 'js':
      return <StyledFontAwesomeIcon icon={faFileCode} />;

    default:
      return <StyledFontAwesomeIcon icon={faFile} />;
  }
};
